require('bootstrap-select')

$.fn.selectpicker.Constructor.DEFAULTS.style = ''
$.fn.selectpicker.Constructor.DEFAULTS.styleBase = 'form-control'
$.fn.selectpicker.Constructor.DEFAULTS.virtualScroll = false
$.fn.selectpicker.Constructor.DEFAULTS.selectedTextFormat = 'count > 1'
$.fn.selectpicker.Constructor.BootstrapVersion = '4'

$(function () {
    const selects = $('.selectpicker')
    selects.selectpicker('refresh')
    selects.on('change', function () {
        $(this).selectpicker('refresh')
    })
})
